import { UserData } from '../userSlice';
import baseApi from './baseApi';

export type UserInfo = {
  user: UserData;
  site: UserSiteData;
  orgAccount: UserOrgAccountData;
};

export type UserSiteData = {
  id: number;
  name: string;
  mode: 'adult' | 'child';
};

export type UserOrgAccountData = {
  id: number;
  name: string;
  status: 'active' | 'inactive';
};

// Define a service using a base URL and inject endpoints

export const userInfoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserInfo: builder.query<UserInfo, string | null>({
      query: (siteId) => `/api/sites/${siteId}/accountInfo?context=member`,
      providesTags: ['User'],
    }),
    getUserId: builder.query<number, string | null>({
      query: (siteId) => `/api/sites/${siteId}/accountInfo?context=member`,
      transformResponse: (userInfo: UserInfo) => {
        const { user } = userInfo;
        return user.id;
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetUserIdQuery, useGetUserInfoQuery } = userInfoApi;
